import { render, staticRenderFns } from "./SettingsLogs.vue?vue&type=template&id=83795ba6"
import script from "./SettingsLogs.vue?vue&type=script&lang=js"
export * from "./SettingsLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports